import { render } from "./OrderInvoiceItem.vue?vue&type=template&id=f00edd04&scoped=true"
import script from "./OrderInvoiceItem.vue?vue&type=script&lang=js"
export * from "./OrderInvoiceItem.vue?vue&type=script&lang=js"

import "./OrderInvoiceItem.vue?vue&type=style&index=0&id=f00edd04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f00edd04"]])

export default __exports__